<template>
    <div :key="iteration">
        <form :key="iteration" class="selector">
            <div class="form-group form-group-selectr">
                <label for="scheme">Scheme</label>

                <select id="scheme" class="form-control" name="scheme" v-model="value" @change.stop="updateValue($event)">
                    <option v-for="option in options" :value="option.id" v-html="option.value"></option>
                </select>
            </div>
        </form>
    </div>
</template>

<script>
    import VisibleSelectorWidget from './VisibleSelectorWidget';

    export default {
        extends: VisibleSelectorWidget,
        created() {
            this.render();
            this.registerParameterListener('range');
        },
        methods: {
            broadcast(value) {
                window.events.emit('updateScheme', parseInt(value));
            }
        }
    }
</script>
